import { FC } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { LogoWrapper } from "./Header.styles";
import AkbankLogo from "assets/images/logo/akbank.svg";
import { NavBar, ProfileMenu } from "components";
import useOtp from "helpers/hooks/useOtp";
import { setMenuClick } from "redux/slices/StepSlice";

interface DesktopHeaderProps {
  loginScreen: boolean;
}

const DesktopHeader: FC<DesktopHeaderProps> = ({ loginScreen }) => {
  const dispatch = useAppDispatch();
  const isOtp = useOtp();

  const { userOtp } = useAppSelector((state) => state.otp);
  const { isVisibleProfileMenu } = useAppSelector(
    (state) => state.merchantSwitch
  );
  const {
    firstPassChange,
    firstPassChangeAdmin,
    firstPassChangeAdminGuv,
  } = useAppSelector((state) => state.PassRefPersonelInfo);

  return (
    <>
      <LogoWrapper isLoginScreen={loginScreen}>
        <Link to='/' onClick={() => dispatch(setMenuClick(0))}>
          <img src={AkbankLogo} alt='Akbank Logo' height='13px' width='110px' />
        </Link>
      </LogoWrapper>
      {isOtp &&
        ((userOtp?.NextScreens?.includes("B") && isVisibleProfileMenu) ||
          (userOtp?.NextScreens?.includes("N") && firstPassChange) ||
          (userOtp?.NextScreens?.includes("S") && firstPassChangeAdmin) ||
          (userOtp?.NextScreens?.includes("G") && firstPassChangeAdminGuv) ||
          userOtp?.NextScreens?.length === 0) && (
          <>
            <NavBar />
            <ProfileMenu />
          </>
        )}
    </>
  );
};

export default DesktopHeader;
